import { createSlice } from '@reduxjs/toolkit';

interface TeamState {
	allUsers: [];
	pageNumber: number;
}

const initialState: TeamState = {
	allUsers: [],
	pageNumber: 1,
};

export const teamSlice = createSlice({
	name: 'team',
	initialState,
	reducers: {
		setAllUsers: (state, action) => {
			state.allUsers = action.payload;
		},
		setPageNumber: (state, action) => {
			state.pageNumber = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { setAllUsers, setPageNumber } = teamSlice.actions;

export default teamSlice.reducer;
